import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { AuthGuard } from 'app/auth/auth.guard';
import { TranslateModule } from '@ngx-translate/core';
import { HomeV2Component } from './home-v2.component';
// import { LayoutModule } from '@angular/cdk/layout';
// import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { FlexLayoutModule } from '@angular/flex-layout';
import { IvyCarouselModule } from "angular-responsive-carousel";
import { ContentSlidersComponent } from './content-sliders/content-sliders.component';
import { ContentActivityComponent } from './content-activity/content-activity.component';
import { ContentProductsComponent } from './content-products/content-products.component';
import { ContentVideoComponent } from './content-video/content-video.component';
// import {MatTableModule} from '@angular/material/table';
import { LoadingComponent } from 'app/main/login/loading/loading.component';
const rutas = [
  {
    path     : 'homepage',
    component: HomeV2Component,
    canActivate: [AuthGuard]
  },
];

@NgModule({
  declarations: [HomeV2Component, ContentSlidersComponent, ContentActivityComponent, ContentProductsComponent, ContentVideoComponent,LoadingComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(rutas),
    TranslateModule,
    // NoopAnimationsModule,
    // LayoutModule,
    MatButtonModule,
    MatCardModule,
    MatGridListModule,
    MatIconModule,
    MatMenuModule,
    FlexLayoutModule,
    IvyCarouselModule,
    // MatTableModule,
  ]
})
export class HomeV2Module { }
